import {FC} from "react";
import {BeneficiaryMainComponent} from "../../components";
import {PageEnum, SupplierCustomerTypeEnum} from "../../models";

export const CustomerPage: FC = () => {
    //#region html
    return (<BeneficiaryMainComponent formId={PageEnum.Customers} type={SupplierCustomerTypeEnum.Customer}/>);
    //#endregion
};
